import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#fff',
    boxShadow: theme.shadows[1],
  },
}))

export default useStyles
